/**
 * Sidebar Spacing Fix - Dynamic Solution
 * Ensures consistent spacing across all templates (index, collection, pages, etc.)
 * Matches the perfect spacing from collection.subcategory.liquid
 */

(function() {
  'use strict';

  function fixSidebarSpacing() {
    const sidebarModules = document.querySelectorAll('.sidebar-module');
    
    if (!sidebarModules || sidebarModules.length === 0) {
      return;
    }

    sidebarModules.forEach(function(module, index) {
      if (index === 0) {
        module.style.marginTop = '0px';
        module.style.paddingTop = '0px';
      } else {
        module.style.marginTop = '18px';
      }
      
      module.style.marginBottom = '0px';
      module.style.paddingBottom = '0.2px';
    });

    const filterContainer = document.querySelector('#collection-filters-container');
    if (filterContainer) {
      filterContainer.style.marginBottom = '0px';
      filterContainer.style.paddingBottom = '0px';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSidebarSpacing);
  } else {
    fixSidebarSpacing();
  }

  window.addEventListener('load', fixSidebarSpacing);
  
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldFix = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList.contains('sidebar-module') || node.querySelector('.sidebar-module'))) {
              shouldFix = true;
            }
          });
        }
      });
      if (shouldFix) {
        fixSidebarSpacing();
      }
    });

    const targetNode = document.querySelector('.sticky-content, .sidebar-container, .c-sticky-content');
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
  }
})();
